const DEFAULT_ROBOT_FONT_FAMILY = "Roboto:100,300,400,500";

const SOFIA_PRO_FONT_NAME = "sofiaPro";
const LATO_FONT_NAME = "Lato";
const NEW_SOFIA_PRO_FONT_NAME = "newSofiaPro";

const FONT_HOSTING_DATA = {
  [SOFIA_PRO_FONT_NAME]: { adobeFontKitId: "usz0ztd", asyncAdobeFontKitId: "gnf7xqu" },
  [LATO_FONT_NAME]: { adobeFontKitId: "ztm3iic" },
  [NEW_SOFIA_PRO_FONT_NAME]: { adobeFontKitId: "sya2bsw" }
};

module.exports = {
  SOFIA_PRO_FONT_NAME,
  LATO_FONT_NAME,
  NEW_SOFIA_PRO_FONT_NAME,
  FONT_HOSTING_DATA,
  DEFAULT_ROBOT_FONT_FAMILY
};
